export class DhCustomer {
    path: string;
    name: string;
}
